var render = function render(){var _vm=this,_c=_vm._self._c;return _c('figure',{class:['image', _vm.ratio, { 'is-center': _vm.isCenter }],style:({ maxWidth: _vm.width + 'px', maxHeight: _vm.height + 'px' })},[(_vm.isLoading)?_c('circles-loader',{attrs:{"bg":false,"parent":_vm.$el,"color":"#ddd","width":"64px","height":"64px"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }